<div class="d-flex align-items-center">
  <input
    [id]="inputElementId"
    type="text"
    [(ngModel)]="momentValue"
    [placeholder]="placeholder"
    [matDatepicker]="datepicker"
    [min]="minDate"
    [max]="getMaxDate()"
    (focus)="datepicker.open()"
    (click)="datepicker.open()"
    class="form-control"
    (ngModelChange)="onValueChange()"
  />

  @if (clearable) {
  <mat-icon matDatepickerToggleIcon (click)="clearValue()"> clear </mat-icon>
  }

  <mat-datepicker
    #datepicker
    id="{{ inputElementId }}-datepicker"
  ></mat-datepicker>
</div>
